<template>
  <div class="tab">
    <slot />
  </div>
</template>
